// AUTO-GENERATED by scripts/build-registry.js. Do not edit. Flattened by-section pool
// (topic + preamble discarded); each generator stamped with its lesson sources (PLAN §5.0).
import g0 from '../lessons/air-law/adiz/adiz.js';
import g1 from '../lessons/air-law/airspace-classes/airspace-classes.js';
import g2 from '../lessons/air-law/alcohol-drugs/alcohol-drugs.js';
import g3 from '../lessons/air-law/clearances-instructions/clearances-instructions.js';
import g4 from '../lessons/air-law/cruising-altitude/cruising-altitude.js';
import g5 from '../lessons/air-law/documents/documents.js';
import g6 from '../lessons/air-law/flight-plans/flight-plans.js';
import g7 from '../lessons/air-law/forest-fire-restriction/forest-fire-restriction.js';
import g8 from '../lessons/air-law/lahso/lahso.js';
import g9 from '../lessons/air-law/laser-directed-light/laser-directed-light.js';
import g10 from '../lessons/air-law/light-signals/light-signals.js';
import g11 from '../lessons/air-law/low-level-speed/low-level-speed.js';
import g12 from '../lessons/air-law/medical/medical-expiry.js';
import g13 from '../lessons/air-law/mf-uncontrolled/mf-uncontrolled.js';
import g14 from '../lessons/air-law/minimum-altitude/minimum-altitude.js';
import g15 from '../lessons/air-law/notams/notams.js';
import g16 from '../lessons/air-law/oxygen/oxygen.js';
import g17 from '../lessons/air-law/portable-electronic-devices/portable-electronic-devices.js';
import g18 from '../lessons/air-law/radio-failure/radio-failure.js';
import g19 from '../lessons/air-law/recency/recency.js';
import g20 from '../lessons/air-law/right-of-way/right-of-way.js';
import g21 from '../lessons/air-law/traffic-circuit/traffic-circuit.js';
import g22 from '../lessons/air-law/transponder-codes/transponder-codes.js';
import g23 from '../lessons/air-law/transponder-equipment/transponder-equipment.js';
import g24 from '../lessons/air-law/vfr-equipment/vfr-equipment.js';
import g25 from '../lessons/air-law/vfr-minima/vfr-minima.js';
import g26 from '../lessons/navigation/airspeeds/ias-cas-tas.js';
import g27 from '../lessons/navigation/cfs-entry/cfs-entry.js';
import g28 from '../lessons/navigation/chart-distance/chart-distance.js';
import g29 from '../lessons/navigation/chart-symbols/chart-symbols.js';
import g30 from '../lessons/navigation/chart-track/chart-track.js';
import g31 from '../lessons/navigation/fuel/fuel.js';
import g32 from '../lessons/navigation/heading-chain/heading-chain.js';
import g33 from '../lessons/navigation/map-projections/map-projections.js';
import g34 from '../lessons/navigation/nav-definitions/nav-definitions.js';
import g35 from '../lessons/navigation/radio-nav-aids/radio-nav-aids.js';
import g36 from '../lessons/navigation/time-speed-distance/tsd-eta.js';
import g37 from '../lessons/navigation/time-zones/utc-local.js';
import g38 from '../lessons/navigation/wind-triangle/wind-triangle.js';
import g39 from '../lessons/meteorology/air-composition/air-composition.js';
import g40 from '../lessons/meteorology/air-masses/air-masses.js';
import g41 from '../lessons/meteorology/altimeter-error/altimeter-error.js';
import g42 from '../lessons/meteorology/atmosphere/atmosphere.js';
import g43 from '../lessons/meteorology/cloud-base/cloud-base.js';
import g44 from '../lessons/meteorology/clouds/clouds.js';
import g45 from '../lessons/meteorology/density-altitude/density-altitude.js';
import g46 from '../lessons/meteorology/fb-decode/fb-decode.js';
import g47 from '../lessons/meteorology/flight-categories/flight-categories.js';
import g48 from '../lessons/meteorology/fog/fog.js';
import g49 from '../lessons/meteorology/freezing-level/freezing-level.js';
import g50 from '../lessons/meteorology/fronts/fronts.js';
import g51 from '../lessons/meteorology/gfa/gfa.js';
import g52 from '../lessons/meteorology/icing/icing.js';
import g53 from '../lessons/meteorology/metar/metar-decode.js';
import g54 from '../lessons/meteorology/pirep-decode/pirep-decode.js';
import g55 from '../lessons/meteorology/pressure-altitude/pressure-altitude.js';
import g56 from '../lessons/meteorology/pressure-systems/pressure-systems.js';
import g57 from '../lessons/meteorology/sigmet-airmet/sigmet-airmet.js';
import g58 from '../lessons/meteorology/stability/stability.js';
import g59 from '../lessons/meteorology/taf-decode/taf-decode.js';
import g60 from '../lessons/meteorology/temperature-inversions/temperature-inversions.js';
import g61 from '../lessons/meteorology/thunderstorms/thunderstorms.js';
import g62 from '../lessons/meteorology/turbulence/turbulence.js';
import g63 from '../lessons/meteorology/upper-winds/fb-interpolation.js';
import g64 from '../lessons/meteorology/weather-observations/weather-observations.js';
import g65 from '../lessons/meteorology/weather-services/weather-services.js';
import g66 from '../lessons/meteorology/wind/wind.js';
import g67 from '../lessons/aeronautics/abnormal-combustion/abnormal-combustion.js';
import g68 from '../lessons/aeronautics/adverse-yaw/adverse-yaw.js';
import g69 from '../lessons/aeronautics/alcohol-fitness/alcohol-fitness.js';
import g70 from '../lessons/aeronautics/carburetor-icing/carburetor-icing.js';
import g71 from '../lessons/aeronautics/compass-errors/compass-errors.js';
import g72 from '../lessons/aeronautics/crosswind/crosswind.js';
import g73 from '../lessons/aeronautics/drag/drag.js';
import g74 from '../lessons/aeronautics/electrical-system/electrical-system.js';
import g75 from '../lessons/aeronautics/engine-ignition/engine-ignition.js';
import g76 from '../lessons/aeronautics/flight-controls/flight-controls.js';
import g77 from '../lessons/aeronautics/four-forces/four-forces.js';
import g78 from '../lessons/aeronautics/fuel-grades/fuel-grades.js';
import g79 from '../lessons/aeronautics/gyroscopic-instruments/gyroscopic-instruments.js';
import g80 from '../lessons/aeronautics/hazardous-attitudes/hazardous-attitudes.js';
import g81 from '../lessons/aeronautics/hydroplaning/hydroplaning.js';
import g82 from '../lessons/aeronautics/hypoxia/hypoxia.js';
import g83 from '../lessons/aeronautics/imsafe/imsafe.js';
import g84 from '../lessons/aeronautics/pitot-static/pitot-static.js';
import g85 from '../lessons/aeronautics/propeller-effects/propeller-effects.js';
import g86 from '../lessons/aeronautics/propeller-pitch/propeller-pitch.js';
import g87 from '../lessons/aeronautics/runway-markings/runway-markings.js';
import g88 from '../lessons/aeronautics/scuba-diving/scuba-diving.js';
import g89 from '../lessons/aeronautics/spatial-disorientation/spatial-disorientation.js';
import g90 from '../lessons/aeronautics/stability/stability.js';
import g91 from '../lessons/aeronautics/stall-speed/stall-speed-bank.js';
import g92 from '../lessons/aeronautics/stalls-spins/stalls-spins.js';
import g93 from '../lessons/aeronautics/surface-contamination/surface-contamination.js';
import g94 from '../lessons/aeronautics/takeoff-landing-distance/takeoff-landing-distance.js';
import g95 from '../lessons/aeronautics/trapped-gas/trapped-gas.js';
import g96 from '../lessons/aeronautics/turn-performance/turn-radius.js';
import g97 from '../lessons/aeronautics/turn-rate/turn-rate.js';
import g98 from '../lessons/aeronautics/v-speeds/v-speeds.js';
import g99 from '../lessons/aeronautics/wake-turbulence/wake-turbulence.js';
import g100 from '../lessons/aeronautics/weight-balance/weight-balance.js';
import g101 from '../lessons/aeronautics/weight-balance-limits/weight-balance-limits.js';

// Shallow-clone + attach sources; generate() is a closure (no `this`), so spread is safe.
const stamp = (g, sources) => ({ ...g, sources });

export const GENERATORS = [
  stamp(g0, ["CARs 602.145"]),
  stamp(g1, ["CARs 601.01","CARs 601.02","CARs 601.03","CARs 601.04","CARs 601.06","CARs 601.09","TC AIM RAC 2.8"]),
  stamp(g2, ["CARs 602.03"]),
  stamp(g3, ["CARs 602.31","TC AIM RAC 1.6"]),
  stamp(g4, ["CARs 602.34"]),
  stamp(g5, ["CARs 202.26","CARs 605.03","CARs 605.03.1","CARs 605.04","CARs 605.92","CARs 605.95","CARs 606.02","CARs 401.03","RIC-21 (ISED ROC-A study guide)"]),
  stamp(g6, ["CARs 602.73","CARs 602.75","CARs 602.77","TC AIM RAC 3.5"]),
  stamp(g7, ["CARs 601.15","CARs 601.17"]),
  stamp(g8, ["TC AIM RAC 4.4.9"]),
  stamp(g9, ["CARs 601.19","CARs 601.20","CARs 601.21"]),
  stamp(g10, ["TC AIM RAC 4.2.11","TC AIM RAC 4.4.7"]),
  stamp(g11, ["CARs 602.32"]),
  stamp(g12, ["CARs 404.04(6)","CARs 404.04(7)","CARs 404.10(3)"]),
  stamp(g13, ["CARs 602.97","CARs 602.100","CARs 602.101","TC AIM RAC 4.5","TC AIM RAC 1.2.1 (UNICOM)"]),
  stamp(g14, ["CARs 602.14"]),
  stamp(g15, ["CARs 602.71","TC AIM MAP"]),
  stamp(g16, ["CARs 605.31","CARs 605.32"]),
  stamp(g17, ["CARs 602.08"]),
  stamp(g18, ["CARs 602.138","CARs 602.137","TC AIM RAC","TC AIM COM"]),
  stamp(g19, ["CARs 401.05(1)","CARs 401.05(2)","Personnel Licensing Standards 421.05 (recurrent-training activities)","TC Self-Paced Study Program (recency)"]),
  stamp(g20, ["CARs 602.19"]),
  stamp(g21, ["CARs 602.96"]),
  stamp(g22, ["TC AIM COM 8.4","TC AIM COM 8.6","TC AIM COM 8.7","TC AIM COM 8.8"]),
  stamp(g23, ["CARs 605.35","CARs 601.03","TC AIM COM 8.1","TC AIM COM 8.2"]),
  stamp(g24, ["CARs 602.60","CARs 605.14","CARs 605.16"]),
  stamp(g25, ["CARs 602.114","CARs 602.115","CARs 602.117"]),
  stamp(g26, ["AC 100-001 glossary (IAS, TAS definitions)","TP 1102 (ASI correction table: CAS to IAS)","#engine/atmosphere.js (ICAO standard-atmosphere sea-level references)"]),
  stamp(g27, ["NAV CANADA CFS","TC AIM MAP 2.5.3","TC AIM RAC 4.5.4","TC AIM RAC 4.5.5","TC AIM RAC 1.2.1","TP 1102 Runway Numbering"]),
  stamp(g28, ["TC AIM MAP 2.5.1 (VNC 1:500 000 scale)","TC AIM MAP 2.5.2 (VTA 1:250 000 scale)","TP 1102 (one minute of latitude = 1 NM)","AC 100-001 glossary (nm = 1.852 km, nm = 1.152 SM conversions)"]),
  stamp(g29, ["VNC/VTA legend"]),
  stamp(g30, ["TP 1102 (measure true direction against lines of longitude, then apply variation; reciprocal = outbound ±180°)","TC AIM MAP 2.5 (VFR charts)"]),
  stamp(g31, ["CARs 602.88 (VFR fuel reserve, taxi/foreseeable delays)","AC 100-001 glossary (imp gal = 1.201 US gal, gal-to-litre conversions)"]),
  stamp(g32, ["AC 100-001 glossary"]),
  stamp(g33, ["TC AIM MAP 2.5.1","TC AIM MAP 2.5.2","VNC/VTA legend"]),
  stamp(g34, ["AC 100-001 glossary","TP 1102"]),
  stamp(g35, ["TC AIM COM 4.5","TC AIM COM 4.6","TC AIM COM 5.3.1","TC AIM COM 7.3","TC AIM COM 8.1","TC AIM SAR 3.1"]),
  stamp(g36, ["TP 1102, Pilot Navigation (Ground Speed Check)","AC 100-001 glossary (1 nm = 1.152 SM = 1.852 km)"]),
  stamp(g37, ["TC AIM GEN 1.5.3"]),
  stamp(g38, ["TP 1102, Pilot Navigation (Setting Heading, Drift Compensation)","AC 100-001 glossary (1 kt = 1.852 km/h = 1.152 mph, from the nm conversions)"]),
  stamp(g39, ["FAA Aviation Weather Handbook (FAA-H-8083-28)"]),
  stamp(g40, ["FAA Aviation Weather Handbook (FAA-H-8083-28)"]),
  stamp(g41, ["TC AIM AIR 1.5.3","TC AIM AIR 1.5.4"]),
  stamp(g42, ["TC AIM AIR 1.5.1","FAA Aviation Weather Handbook (FAA-H-8083-28)"]),
  stamp(g43, ["TC AIM RPA 3.2.22.8"]),
  stamp(g44, ["TC AIM MET","FAA Aviation Weather Handbook (FAA-H-8083-28)"]),
  stamp(g45, ["TC AIM MET 8.4.3","TC AIM AIR 1.5.1"]),
  stamp(g46, ["TC AIM MET 9.2","TC AIM MET 1.3.7"]),
  stamp(g47, ["TC AIM MET 4.0 (Table 4.3, IFR Outlook Criteria)"]),
  stamp(g48, ["FAA Aviation Weather Handbook (FAA-H-8083-28)"]),
  stamp(g49, ["TC AIM AIR 1.5.1","TC AIM RPA 3.2.22.8","TC AIM MET 4.12"]),
  stamp(g50, ["TC AIM MET","FAA Aviation Weather Handbook (FAA-H-8083-28)"]),
  stamp(g51, ["TC AIM MET 4.0 (Graphic Area Forecast)"]),
  stamp(g52, ["TC AIM AIR 2.12.3 (in-flight airframe icing)","TC AIM MET 2.4 (Table 2.4, Icing Types)","TP 10643 (When in Doubt... aircraft critical surface contamination)"]),
  stamp(g53, ["TC AIM MET 8.1","TC AIM MET 8.2","TC AIM RAC 4.2.5 (ATC passes wind in magnetic)"]),
  stamp(g54, ["TC AIM MET 2.1 (PIREP example, fields)","TC AIM MET 2.2.2 (turbulence intensities)","TC AIM MET 2.4 (icing intensities, Table 2.3)","TC AIM MET 1.2.2 (PIREP heights ASL)"]),
  stamp(g55, ["TC AIM AIR 1.5.1","TC AIM AIR 1.5.3","FAA Aviation Weather Handbook (FAA-H-8083-28)"]),
  stamp(g56, ["TC AIM MET 10.0","TC AIM MET 11.1","FAA Aviation Weather Handbook (FAA-H-8083-28)"]),
  stamp(g57, ["TC AIM MET 5.0 (AIRMET)","TC AIM MET 6.0 (SIGMET)"]),
  stamp(g58, ["FAA Aviation Weather Handbook (FAA-H-8083-28)"]),
  stamp(g59, ["TC AIM MET 7.0"]),
  stamp(g60, ["FAA Aviation Weather Handbook (FAA-H-8083-28)"]),
  stamp(g61, ["FAA Aviation Weather Handbook (FAA-H-8083-28)","TC AIM AIR 2.7 (flight near thunderstorms: hazards)","TC AIM AIR 2.8 (low-level wind shear / microburst)"]),
  stamp(g62, ["FAA Aviation Weather Handbook (FAA-H-8083-28)","TC AIM MET"]),
  stamp(g63, ["TC AIM MET 9.2"]),
  stamp(g64, ["TC AIM MET 8.0 (METAR, SPECI, METAR AUTO)"]),
  stamp(g65, ["TC AIM MET 1.1.2","TC AIM MET 1.1.3","TC AIM MET 1.1.4","TC AIM MET 1.1.5","TC AIM MET 1.3.1"]),
  stamp(g66, ["FAA Aviation Weather Handbook (FAA-H-8083-28)","TC AIM MET 10.0"]),
  stamp(g67, ["TP 1102","POH/AFM"]),
  stamp(g68, ["TP 1102"]),
  stamp(g69, ["TC AIM AIR 3.2.1","TC AIM AIR 3.9"]),
  stamp(g70, ["TP 1102 (Flight Training Manual)","TC AIM AIR","POH/AFM"]),
  stamp(g71, ["TP 1102 (Flight Training Manual)","AC 100-001 glossary (deviation)"]),
  stamp(g72, ["TP 1102 (Flight Training Manual)"]),
  stamp(g73, ["TP 1102 (Flight Training Manual)"]),
  stamp(g74, ["TP 1102 (Flight Training Manual)","TC AIM AIR","POH/AFM"]),
  stamp(g75, ["TP 1102","POH/AFM"]),
  stamp(g76, ["TP 1102 (Flight Training Manual)"]),
  stamp(g77, ["TP 1102 (Flight Training Manual)"]),
  stamp(g78, ["TC AIM AIR 1.3.1","TP 1102 (Flight Training Manual)"]),
  stamp(g79, ["TP 1102","POH/AFM"]),
  stamp(g80, ["FAA Pilot's Handbook of Aeronautical Knowledge (FAA-H-8083-25)"]),
  stamp(g81, ["TC AIM AIR 1.6.6"]),
  stamp(g82, ["TC AIM AIR 3.2","TC AIM AIR 3.5","FAA Pilot's Handbook of Aeronautical Knowledge (FAA-H-8083-25)"]),
  stamp(g83, ["TC AIM RPA 3.2.7","TC AIM AIR 3.10"]),
  stamp(g84, ["TC AIM AIR 1.5","POH/AFM"]),
  stamp(g85, ["TP 1102"]),
  stamp(g86, ["TP 1102","POH/AFM"]),
  stamp(g87, ["TP 1102","TC AIM AGA"]),
  stamp(g88, ["TC AIM AIR 3.4"]),
  stamp(g89, ["TC AIM AIR 3.7","FAA Pilot's Handbook of Aeronautical Knowledge (FAA-H-8083-25)"]),
  stamp(g90, ["TP 1102 (Flight Training Manual)"]),
  stamp(g91, ["TP 1102 (Flight Training Manual)"]),
  stamp(g92, ["TP 1102 (Flight Training Manual)"]),
  stamp(g93, ["CAR 602.11(1), (2)","TP 1102 (Flight Training Manual)","TC AIM AIR 2.12.2","TP 10643 (When in Doubt... Small and Large Aircraft)"]),
  stamp(g94, ["Aircraft POH/AFM (performance section)","TP 1102 (Flight Training Manual)","TC AIM AGA 1.1.3 + AIR 1.6.7 (CRFI: landing-distance corrections only)"]),
  stamp(g95, ["TC AIM AIR 3.6"]),
  stamp(g96, ["TP 1102 (Flight Training Manual)"]),
  stamp(g97, ["TP 1102 (Flight Training Manual)"]),
  stamp(g98, ["TP 1102 (Flight Training Manual)","Aircraft POH/AFM (ASI markings)"]),
  stamp(g99, ["TC AIM AIR 2.9"]),
  stamp(g100, ["Aircraft POH/AFM (weight & balance section)","TP 1102 (Flight Training Manual)"]),
  stamp(g101, ["POH/AFM"]),
];
